class ChasePaymentRequest {
    public cssUrl!: string;
    public callbackUrl!: string;
    public allowedTypes!: string;
    public formType!: FormType;
    public lang!: Language;
    public amount!: number;
    public orderId!: string;
    public orderDesc?: string;
    public name?: string;
    public customerId?: string;
    public accountVerification?: string;

    public initializeUsingSecureId(orderId: string, amount: number, formType: FormType, language: Language, ...allowedTypes: string[]): void {
        this.amount = amount;
        this.orderId = orderId;

        if (allowedTypes.length > 0) {
            this.allowedTypes = allowedTypes.join('|');
        }
        this.formType = formType;
        this.lang = language;
    }
}

enum FormType {
    Short = 0,
    Tall = 1,
    Iphone = 4,
    Div = 7
}

enum Language {
    English = 'en_US',
    French = 'fr_CA',
    Spanish = 'es_MX'
}

enum FieldsRequired {
    All = 'all',
    Minimum = 'minimum'
}

export { ChasePaymentRequest, FormType, Language, FieldsRequired };